module.exports = __webpack_public_path__ + "static/media/Huis-2-1.516815bc.jpg";